import { Card } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../../context/TokenProvider';
const InspectionDetailCard = ({ children, w = '100%', ...rest }) => {
    const tokens = useTokens();
    const cardStyles = {
        card: {
            boxShadow: '0 2px 4px 0px rgba(26, 26, 26, 0.20)',
            bgColor: tokens.Layer01,
            borderRadius: tokens.BorderRadius02,
        },
        cardBody: {
            padding: 'none',
        },
    };
    return (React.createElement(Card, { w: w, sx: cardStyles.card, ...rest }, children));
};
export default InspectionDetailCard;
